module.exports = __webpack_public_path__ + "img/services-icon2.27df06e5.png";